module.exports = __webpack_public_path__ + "img/level1_running_gun_mask.49da6d40.png";